var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var Environment = /** @class */ (function (_super) {
    __extends(Environment, _super);
    function Environment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Fork an existing environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/fork
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.fork = function (environmentId, body, queryParams) {
        return this.rawFork(Utils.toId(environmentId), Utils.serializeRequestBody(body, {
            id: Utils.toId(environmentId),
            type: 'environment',
            attributes: [],
            relationships: [],
        }), queryParams).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Fork an existing environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/fork
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawFork = function (environmentId, body, queryParams) {
        return this.client.request({
            method: 'POST',
            url: "/environments/".concat(environmentId, "/fork"),
            body: body,
            queryParams: queryParams,
        });
    };
    /**
     * Promote an environment to primary
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/promote
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.promote = function (environmentId) {
        return this.rawPromote(Utils.toId(environmentId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Promote an environment to primary
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/promote
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawPromote = function (environmentId) {
        return this.client.request({
            method: 'PUT',
            url: "/environments/".concat(environmentId, "/promote"),
        });
    };
    /**
     * Rename an environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/rename
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rename = function (environmentId, body) {
        return this.rawRename(Utils.toId(environmentId), Utils.serializeRequestBody(body, {
            id: Utils.toId(environmentId),
            type: 'environment',
            attributes: [],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Rename an environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/rename
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawRename = function (environmentId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/environments/".concat(environmentId, "/rename"),
            body: body,
        });
    };
    /**
     * List all environments
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all environments
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/environments',
        });
    };
    /**
     * Retrieve a environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.find = function (environmentId) {
        return this.rawFind(Utils.toId(environmentId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawFind = function (environmentId) {
        return this.client.request({
            method: 'GET',
            url: "/environments/".concat(environmentId),
        });
    };
    /**
     * Delete a environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.destroy = function (environmentId) {
        return this.rawDestroy(Utils.toId(environmentId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a environment
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/environment/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Environment.prototype.rawDestroy = function (environmentId) {
        return this.client.request({
            method: 'DELETE',
            url: "/environments/".concat(environmentId),
        });
    };
    Environment.TYPE = 'environment';
    return Environment;
}(BaseResource));
export default Environment;
//# sourceMappingURL=Environment.js.map